export default __webpack_public_path__ + "static/media/surveyAd.4a64085f.png";